import { render, staticRenderFns } from "./ProcessWorkGovernChoose.vue?vue&type=template&id=6d6d0d9d"
import script from "./ProcessWorkGovernChoose.vue?vue&type=script&lang=js"
export * from "./ProcessWorkGovernChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports